import React, { useContext } from 'react';
import { Box, Text, ThemeContext } from 'grommet';
import styled from 'styled-components';
import useQuery from 'granite-admin/utils/useQuery';
const StyledBox = styled(Box)`
  border-radius: 15px;
  padding: 1px 10px;
  cursor: pointer;
  & > span:hover {
    text-decoration: underline;
  }
`;
const ClearDashboardFilter = () => {
  const theme = useContext(ThemeContext);
  const {
    updateQuery
  } = useQuery();
  return /*#__PURE__*/React.createElement(Box, {
    flex: {
      shrink: 0
    },
    gap: "small",
    direction: "row",
    margin: {
      left: 'small',
      right: 'small',
      bottom: 'xsmall',
      top: '-10px'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    style: {
      fontStyle: 'italic'
    }
  }, "Displayed data is as per selected dashboard widget and has pre-applied filters"), /*#__PURE__*/React.createElement(StyledBox, {
    background: theme?.graniteTable?.clearDashboardFilter || 'brand',
    focusIndicator: false,
    onClick: () => updateQuery('')
  }, /*#__PURE__*/React.createElement(Text, {
    color: "#ffffff"
  }, " Clear dashboard filters")));
};
export { ClearDashboardFilter };